import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer } from 'react-toastify';
import App from './App';
import AuthApp from './components/Auth/AuthApp';

const rootElement = document.getElementById('root');

ReactDOM.render(
  <>
    <ToastContainer />
    <AuthApp />
  </>,
  document.getElementById('root')
);

const styleLink = document.createElement("link");
styleLink.rel = "stylesheet";
styleLink.href = "https://cdn.jsdelivr.net/npm/semantic-ui/dist/semantic.min.css";
document.head.appendChild(styleLink);


